import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ConstructionIcon from 'app/icons/construction_barrier.svg';

import style from './style.module.scss';

interface Props {
  entity?: Entity;
}

const ErrorNotSupported: FC<Props> = ({ entity }) => {
  const { t } = useTranslation();

  return (
    <div className={style.errorContainer}>
      <ConstructionIcon className={style.errorIcon} />
      <div className={style.errorMessage}>
        <p>{t(`error_not-supported_${entity}`)}</p>
        <p>{t('error_not-supported_sorry')}</p>
      </div>
    </div>
  );
};

ErrorNotSupported.displayName = 'ErrorNotSupported';

export default ErrorNotSupported;
